import jwt_decode from 'jwt-decode';
import { baseURL } from './../../env.js'

const jwtDecode = (token) => {
  // if(token && token.trim().length>0){
    const tokenDecoded = jwt_decode(token);
  //   if(`${tokenDecoded.iss}`===baseURL
  //     || `http://${tokenDecoded.iss}/`===baseURL
  //     || `https://${tokenDecoded.iss}/`===baseURL){
      return tokenDecoded;
  //   }
  // }
  // localStorage.setItem('token', '');
  // window.location = `/login`;
  return null;
}

export default jwtDecode;
